import { c as _c } from "react/compiler-runtime";
import type { DataIdentifier, DocumentViewerCard, PiiJsonValue, TabGroupKind } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import useSession from '@/hooks/use-session';
import BoundingBoxContent from './bounding-box-content';
import ContentCard from './content-card';
import EncryptedKeyValueContent from './encrypted-key-value-content';
import KeyValueContent from './key-value-content';
import ReasonCodeContent from './reason-code-content';
import TableContent from './table-content';
type DecryptedData = Record<string, PiiJsonValue>;
type CenterPanelProps = {
  cards: DocumentViewerCard[];
  selectedTab: TabGroupKind;
  selectedBboxIds: Set<string>;
  onBboxClick: (id: string, pageId?: number) => void;
  onSelectBboxes: (ids: string[]) => void;
  onClearBboxes: (ids: string[]) => void;
  isEncrypted?: boolean;
  onDecryptVaultData?: (fields: DataIdentifier[]) => Promise<DecryptedData | null>;
  documentIdentifier: string;
};
const CenterPanel = t0 => {
  const $ = _c(58);
  const {
    cards,
    selectedTab,
    selectedBboxIds,
    onBboxClick,
    onSelectBboxes,
    onClearBboxes,
    isEncrypted,
    onDecryptVaultData,
    documentIdentifier
  } = t0;
  const {
    t
  } = useTranslation("document-viewer");
  const {
    data: session
  } = useSession();
  const isFirmEmployee = !!session.user?.isFirmEmployee;
  let t1;
  let t2;
  let t3;
  if ($[0] !== cards || $[1] !== documentIdentifier || $[2] !== isEncrypted || $[3] !== isFirmEmployee || $[4] !== onBboxClick || $[5] !== onClearBboxes || $[6] !== onDecryptVaultData || $[7] !== onSelectBboxes || $[8] !== selectedBboxIds || $[9] !== selectedTab || $[10] !== t) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t4;
      if ($[14] !== isFirmEmployee) {
        t4 = card => !card.isFirmEmployeeOnly || isFirmEmployee;
        $[14] = isFirmEmployee;
        $[15] = t4;
      } else {
        t4 = $[15];
      }
      const visibleCards = cards.filter(t4);
      let t5;
      if ($[16] !== t) {
        t5 = t(_temp);
        $[16] = t;
        $[17] = t5;
      } else {
        t5 = $[17];
      }
      let t6;
      if ($[18] !== t) {
        t6 = t(_temp2);
        $[18] = t;
        $[19] = t6;
      } else {
        t6 = $[19];
      }
      let t7;
      if ($[20] !== t) {
        t7 = t(_temp3);
        $[20] = t;
        $[21] = t7;
      } else {
        t7 = $[21];
      }
      let t8;
      if ($[22] !== t) {
        t8 = t(_temp4);
        $[22] = t;
        $[23] = t8;
      } else {
        t8 = $[23];
      }
      let t9;
      if ($[24] !== t) {
        t9 = t(_temp5);
        $[24] = t;
        $[25] = t9;
      } else {
        t9 = $[25];
      }
      let t10;
      if ($[26] !== t5 || $[27] !== t6 || $[28] !== t7 || $[29] !== t8 || $[30] !== t9) {
        t10 = {
          validation: t5,
          extraction: t6,
          tamper_detection: t7,
          classification: t8,
          vault_data: t9
        };
        $[26] = t5;
        $[27] = t6;
        $[28] = t7;
        $[29] = t8;
        $[30] = t9;
        $[31] = t10;
      } else {
        t10 = $[31];
      }
      const tabLabels = t10;
      if (visibleCards.length === 0) {
        let t11;
        if ($[32] !== t) {
          t11 = t(_temp6);
          $[32] = t;
          $[33] = t11;
        } else {
          t11 = $[33];
        }
        let t12;
        if ($[34] !== t11) {
          t12 = <div className="flex items-center justify-center h-full p-4"><p className="text-body-2 text-tertiary">{t11}</p></div>;
          $[34] = t11;
          $[35] = t12;
        } else {
          t12 = $[35];
        }
        t3 = t12;
        break bb0;
      }
      let t11;
      if ($[36] !== isEncrypted || $[37] !== onClearBboxes || $[38] !== onSelectBboxes || $[39] !== selectedBboxIds) {
        t11 = card_0 => {
          if (isEncrypted) {
            return;
          }
          const cardBboxIds = getCardBboxIds(card_0);
          if (cardBboxIds.length === 0) {
            return;
          }
          const allCardSelected = cardBboxIds.every(id => selectedBboxIds.has(id));
          return allCardSelected ? () => onClearBboxes(cardBboxIds) : () => onSelectBboxes(cardBboxIds);
        };
        $[36] = isEncrypted;
        $[37] = onClearBboxes;
        $[38] = onSelectBboxes;
        $[39] = selectedBboxIds;
        $[40] = t11;
      } else {
        t11 = $[40];
      }
      const getSelectAllHandler = t11;
      let t12;
      if ($[41] !== selectedBboxIds || $[42] !== t) {
        t12 = card_1 => {
          const cardBboxIds_0 = getCardBboxIds(card_1);
          const allCardSelected_0 = cardBboxIds_0.length > 0 && cardBboxIds_0.every(id_0 => selectedBboxIds.has(id_0));
          return allCardSelected_0 ? t(_temp7) : t(_temp8);
        };
        $[41] = selectedBboxIds;
        $[42] = t;
        $[43] = t12;
      } else {
        t12 = $[43];
      }
      const getSelectAllLabel = t12;
      t1 = "flex flex-col gap-2 p-2";
      let t13;
      if ($[44] !== documentIdentifier || $[45] !== getSelectAllHandler || $[46] !== getSelectAllLabel || $[47] !== isEncrypted || $[48] !== isFirmEmployee || $[49] !== onBboxClick || $[50] !== onDecryptVaultData || $[51] !== selectedBboxIds || $[52] !== selectedTab || $[53] !== tabLabels) {
        t13 = card_2 => <ContentCard key={`${card_2.kind}-${card_2.displayName}`} headerTitle={tabLabels[selectedTab]} onSelectAll={getSelectAllHandler(card_2)} selectAllLabel={getSelectAllLabel(card_2)} isFirmEmployeeOnly={isFirmEmployee && card_2.isFirmEmployeeOnly}>{card_2.description && <p className="text-caption-2 text-primary mb-3">{card_2.description}</p>}{card_2.content.contentType === "reason_code" && <ReasonCodeContent content={card_2.content} />}{card_2.content.contentType === "bounding_box" && <BoundingBoxContent content={card_2.content} cardKind={card_2.kind} selectedBboxIds={selectedBboxIds} onBboxClick={onBboxClick} isEncrypted={isEncrypted} />}{card_2.content.contentType === "key_value_data" && <KeyValueContent content={card_2.content} />}{card_2.content.contentType === "table_data" && <TableContent content={card_2.content} />}{card_2.content.contentType === "encrypted_key_value_data" && <EncryptedKeyValueContent content={card_2.content} onDecrypt={onDecryptVaultData} documentIdentifier={documentIdentifier} />}</ContentCard>;
        $[44] = documentIdentifier;
        $[45] = getSelectAllHandler;
        $[46] = getSelectAllLabel;
        $[47] = isEncrypted;
        $[48] = isFirmEmployee;
        $[49] = onBboxClick;
        $[50] = onDecryptVaultData;
        $[51] = selectedBboxIds;
        $[52] = selectedTab;
        $[53] = tabLabels;
        $[54] = t13;
      } else {
        t13 = $[54];
      }
      t2 = visibleCards.map(t13);
    }
    $[0] = cards;
    $[1] = documentIdentifier;
    $[2] = isEncrypted;
    $[3] = isFirmEmployee;
    $[4] = onBboxClick;
    $[5] = onClearBboxes;
    $[6] = onDecryptVaultData;
    $[7] = onSelectBboxes;
    $[8] = selectedBboxIds;
    $[9] = selectedTab;
    $[10] = t;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t1 = $[11];
    t2 = $[12];
    t3 = $[13];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[55] !== t1 || $[56] !== t2) {
    t4 = <div className={t1}>{t2}</div>;
    $[55] = t1;
    $[56] = t2;
    $[57] = t4;
  } else {
    t4 = $[57];
  }
  return t4;
};

// Helper to get selectable bbox IDs from a single card (only those with non-null bbox)
const getCardBboxIds = (card: DocumentViewerCard): string[] => {
  if (card.content.contentType !== 'bounding_box') return [];
  // Only include bboxes that have a non-null bbox property (can be highlighted on document)
  return card.content.bboxGroups.flatMap(g => g.bboxes.filter(b => b.bbox !== null).map(b => b.id));
};
export default CenterPanel;
function _temp($) {
  return $.tabs.validation;
}
function _temp2($_0) {
  return $_0.tabs.extraction;
}
function _temp3($_1) {
  return $_1.tabs.tamperDetection;
}
function _temp4($_2) {
  return $_2.tabs.classification;
}
function _temp5($_3) {
  return $_3.tabs.vaultData;
}
function _temp6($_4) {
  return $_4.centerPanel.noDataAvailable;
}
function _temp7($_5) {
  return $_5.centerPanel.unselectAll;
}
function _temp8($_6) {
  return $_6.centerPanel.selectAll;
}